import { Card, Checkbox, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { GetConsultationResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { dayStringMonthYearFormat, hourMinutesFormat } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  data?: GetConsultationResponse
}

export const DetailsGeneralInformationCard = ({ data }: Props) => {
  const { t, currentLang } = useLocales()

  return (
    <Card>
      <Card title={t('users.general_info')}>
        <Row gutter={[24, 24]} align="middle">
          {data?.generalInformation?.consultationType && (
            <Col span={12} xl={6}>
              <Flex vertical gap={8}>
                <Text weight={700}>{t('consultations.consultation_type')}</Text>

                <Text>
                  {t(
                    `consultation_form.type.${data?.generalInformation?.consultationType}`
                  )}
                </Text>
              </Flex>
            </Col>
          )}

          <Col span={12} xl={6}>
            <Flex vertical gap={8}>
              <Text weight={700}>{t('consultations.consultation_date')}</Text>

              <Text>
                {dayjs(data?.generalInformation?.consultationDate)
                  .locale(currentLang.value)
                  .format(dayStringMonthYearFormat)}
              </Text>
            </Flex>
          </Col>

          <Col span={12} xl={6}>
            <Flex vertical gap={8}>
              <Text weight={700}>{t('common.hour')}</Text>

              <Text>
                {dayjs(data?.generalInformation?.consultationDate).format(
                  hourMinutesFormat
                )}
              </Text>
            </Flex>
          </Col>

          <Col span={12} xl={6}>
            <Checkbox disabled checked={!!data?.pregnancyMonitoringId}>
              {t('consultations.pregnant_women')}
            </Checkbox>
          </Col>
        </Row>
      </Card>
    </Card>
  )
}
